export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/three_essentials-bbdd905c8ff7e32b47f947a965278477.svg";